
import Vue from 'vue';
import Modal from '@/components/Modal.vue';
import { NormalizedIndexBase } from '@/types/apptypes';
import * as Api from '@/api';
export default Vue.extend({
	components: {Modal},
	props: {
		corpus: Object as () => NormalizedIndexBase
	},
	data: () => ({
		content: '',
		loading: false,
		error: ''
	}),
	methods: {
		save() {
			this.loading = true;
			Api.blacklab.postShares(this.corpus.id, this.content.split('\n'))
			.then(r => {
				this.$emit('success', r.status.message)
				this.$emit('close');
			})
			.catch((e: Api.ApiError) => this.error = `Could not save shares for corpus "${this.corpus.displayName}": ${e.message}`)
			.finally(() => this.loading = false);
		}
	},
	created() {
		this.loading = true;
		Api.blacklab.getShares(this.corpus.id)
		.then(shares => this.content = shares.join('\n'))
		.catch((e: Api.ApiError) => this.error = `Could not retrieve share list for corpus "${this.corpus.displayName}": ${e.message}`)
		.finally(() => this.loading = false);
	}
});
